import ImageWithFallback from "components/ImageWithFallback"
import React from "react"
import {Component} from "react"
import {Link} from "react-router-dom"
import {Card} from "semantic-ui-react"

export default class CategoryCard extends Component {

	render() {
		const {category, hasParents, className = "", title = true, fallback = "//placehold.it/420x240/f5f5f5/&text=X"} = this.props

		if ( !hasParents ) {
			return <Card className={`CategoryCard ${className}`} as={Link}
						 to={`/collection/${category.map_id}`}>
				<ImageWithFallback src={category.img_src} fallback={fallback} />


				{title && <div className={"onHover pa3 text-box"}>
					<span className="category-title">{category.desc.short_des}</span>
				</div>}

			</Card>
		}

		if ( category.getParents ) {
			let parents = category.getParents()
			const base = `/collection/${parents.map( id => `${id}/` ).join( "" )}${category.map_id}/`
			return <Card
				className={`CategoryCard ${className}`}>
				<div className="white pa2 pa3-ns">
					<Link className={"white db pa3 f4 b hover-white"} to={base}>{category.desc.short_des}</Link>
					{category.children.map( subcategory => {
						return <Link className="f6 white-80 db ph3 pv1 hover-white" to={`${base}${subcategory.map_id}`} key={subcategory.map_id}>{subcategory.title}</Link>
					} )}
				</div>
			</Card>
		}

		return null
	}
}


// WEBPACK FOOTER //
// ./src/theme/lindtbShop/plugin/CategoryShortcuts/CategoryCard.js